var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetZoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8905_12182)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.634277,
    width: 40,
    height: 40,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8905_12182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8393 19.8709H26.3844C26.0368 16.9298 23.7045 14.5974 20.7634 14.2499V11.795C20.7634 11.7066 20.6911 11.6343 20.6027 11.6343H19.3973C19.3089 11.6343 19.2366 11.7066 19.2366 11.795V14.2499C16.2955 14.5974 13.9632 16.9298 13.6156 19.8709H11.1607C11.0723 19.8709 11 19.9432 11 20.0316V21.237C11 21.3253 11.0723 21.3977 11.1607 21.3977H13.6156C13.9632 24.3387 16.2955 26.6711 19.2366 27.0187V29.4736C19.2366 29.562 19.3089 29.6343 19.3973 29.6343H20.6027C20.6911 29.6343 20.7634 29.562 20.7634 29.4736V27.0187C23.7045 26.6711 26.0368 24.3387 26.3844 21.3977H28.8393C28.9277 21.3977 29 21.3253 29 21.237V20.0316C29 19.9432 28.9277 19.8709 28.8393 19.8709ZM20 25.5361C17.292 25.5361 15.0982 23.3423 15.0982 20.6343C15.0982 17.9262 17.292 15.7325 20 15.7325C22.708 15.7325 24.9018 17.9262 24.9018 20.6343C24.9018 23.3423 22.708 25.5361 20 25.5361Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 18.226C19.3554 18.226 18.7528 18.4751 18.2967 18.9332C17.8407 19.3892 17.5896 19.9919 17.5896 20.6367C17.5896 21.2816 17.8407 21.8843 18.2967 22.3403C18.7528 22.7943 19.3574 23.0475 20.0003 23.0475C20.6432 23.0475 21.2479 22.7963 21.7039 22.3403C22.1579 21.8843 22.411 21.2796 22.411 20.6367C22.411 19.9939 22.1599 19.3892 21.7039 18.9332C21.4812 18.708 21.2158 18.5294 20.9233 18.408C20.6308 18.2866 20.317 18.2247 20.0003 18.226Z",
    fill: "black",
    fillOpacity: 0.85
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.13428,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#DEDCDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8905_12182",
    x: 0,
    y: 0.634277,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8905_12182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8905_12182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8905_12182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11.6343)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetZoom);
export default __webpack_public_path__ + "static/media/reset-zoom.207aaae721cf178880ef4017695f2cf4.svg";
export { ForwardRef as ReactComponent };